import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import DOMPurify from 'dompurify';

function sanitizeInput(input: string): string {
  return DOMPurify.sanitize(input);
}

function containsScript(input: string): boolean {
  const scriptPattern = /<\s*script.*?>.*?<\s*\/\s*script\s*.*?>/gi;
  return scriptPattern.test(input);
}

function PaymentFail(): JSX.Element {
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const rawErrorMessage = queryParams.get('error') ?? '';
    const sanitizedErrorMessage = sanitizeInput(rawErrorMessage); // Sanitize the error message

    if (rawErrorMessage) {
      if (sanitizedErrorMessage !== rawErrorMessage || containsScript(rawErrorMessage)) {
        // XSS attack detected, set a generic error message
        setErrorMessage('Transaction Error. Please try again later.');
      } else {
        // No XSS attack, set the sanitized error message
        setErrorMessage(sanitizedErrorMessage);
      }
    } else {
      // No 'error' parameter found in URL, set a generic error message
      setErrorMessage('');
    }


  }, []);

  return (
    <Box>
      <Box textAlign='center'>
        <img
          src='/images/fail.png'
          alt='check'
          width='60'
          style={{ marginBottom: '18px' }}
        />
        <Typography variant='h6' gutterBottom>
          Transaction Declined
        </Typography>
        <div>
          <span
            style={{
              fontSize: '14px',
              color: '#9B9B9B',
              fontWeight: 400,
              marginTop: '8px', 
              display: 'block',
            }}
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          />
        </div>
      </Box>
    </Box>
  );
}

export default PaymentFail;
